import { useEffect, useState } from 'react';

import { useInviteUser } from '../hooks/useInviteUser';
import FormField from './ui/FormField';
import Modal from './ui/Modal';
import StatusMessage from './ui/StatusMessage';

const roleOptions = ['owner', 'admin', 'manager', 'staff'];

const roleLabels = {
  owner: 'Owner',
  admin: 'Admin',
  manager: 'Manager',
  staff: 'Staff',
};

export default function InviteUserModal({ open, onClose, onSuccess }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('staff');
  const { sendInvite, loading, error } = useInviteUser();

  useEffect(() => {
    if (open) {
      setName('');
      setEmail('');
      setRole('staff');
    }
  }, [open]);

  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const result = await sendInvite({ name, email, role });

    if (result?.success) {
      await onSuccess?.();
      onClose();
    }
  };

  return (
    <Modal
      isOpen={open}
      onClose={handleClose}
      title="Invite User"
      hideFooter
    >
      <form className="modal-form" onSubmit={handleSubmit}>
        <FormField
          name="invite-name"
          label="Full Name"
          required
          value={name}
          onChange={setName}
        />

        <FormField
          name="invite-email"
          label="Email"
          type="email"
          required
          value={email}
          onChange={setEmail}
        />

        <div className="form-group">
          <label htmlFor="field-invite-role">Role *</label>
          <select
            id="field-invite-role"
            className="select"
            value={role}
            required
            onChange={(event) => setRole(event.target.value)}
          >
            {roleOptions.map((option) => (
              <option key={option} value={option}>
                {roleLabels[option]}
              </option>
            ))}
          </select>
        </div>

        <StatusMessage tone="error" message={error} />

        <div className="modal-actions">
          <button
            type="button"
            onClick={handleClose}
            disabled={loading}
            className="button"
          >
            Cancel
          </button>

          <button
            type="submit"
            disabled={loading}
            className="button button-primary"
          >
            {loading ? 'Sending...' : 'Send Invitation'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
